@if (componentData.data$ | async; as component) {
  <div
    class="text-video"
    [ngClass]="{
      'background--dark': component.backgroundColor === backgroundColor.GREY,
      'pb-0': component.removeBottomSpacing | safeCheck,
    }"
  >
    <div class="container">
      <div class="row">
        @if (!isTextLessVideo(component)) {
          <div
            class="text-video__container col col-md-5"
            [ngClass]="{ reverse: component.imageAlignment === alignment.LEFT }"
          >
            <div class="text-video__content">
              @if (component.title && component.title !== '') {
                <h2 class="text-video__title">
                  {{ component.title }}
                </h2>
              }
              <div
                class="text-video__text"
                [innerHTML]="component.bodyText"
              ></div>
            </div>
          </div>
        }
        <div
          #playerContainer
          class="text-video__video"
          [class]="
            isTextLessVideo(component) ? 'col col-md-12' : 'col col-md-7'
          "
        >
          @if (cookieAccepted$() | async) {
            @if (notPlayedYet$ | async) {
              <div class="text-video__thumbnail">
                <img
                  class="youtube-thumbnail"
                  [src]="
                    '//i.ytimg.com/vi_webp/' +
                    component.videoId +
                    '/maxresdefault.webp'
                  "
                  alt="{{ 'youtube.youtubePreview' | transloco }}"
                />
                <button
                  class="youtube-play-btn btn btn-primary"
                  (click)="play()"
                >
                  <fa-icon [icon]="faPlay"></fa-icon>
                </button>
              </div>
            } @else {
              <youtube-player
                class="text-video__player"
                [videoId]="component.videoId"
                [playerVars]="{ rel: 0, autoplay: 1 }"
                [width]="width - 30"
                (ready)="onPlayerReady($event)"
              ></youtube-player>
            }
            <ng-template #player>
              <youtube-player
                class="text-video__player"
                [videoId]="component.videoId"
                [playerVars]="{ rel: 0, autoplay: 1 }"
                [width]="width - 30"
                (ready)="onPlayerReady($event)"
              ></youtube-player>
            </ng-template>
          } @else {
            <div class="text-video__cookie">
              <div class="container col col-md-8">
                <p>
                  {{ 'youtube.cookieTextPart1' | transloco }} (<a
                    [href]="'https://www.youtube.com'"
                    [target]="'_blank'"
                    >{{ 'youtube.youtubeLink' | transloco }}</a
                  >){{ 'youtube.cookieTextPart2' | transloco }}
                </p>
                <button
                  (click)="openCookiebotModal($event)"
                  class="btn btn-primary"
                >
                  {{ 'youtube.manageCookies' | transloco }}
                </button>
                <a
                  [href]="
                    'https://www.youtube.com/watch?v=' + component.videoId
                  "
                  [target]="'_blank'"
                >
                  <fa-icon [icon]="faArrow" class="thin"></fa-icon
                  >{{ 'youtube.watchOnYoutube' | transloco }}</a
                >
              </div>
            </div>
          }
          <ng-template #manageCookies>
            <div class="text-video__cookie">
              <div class="container col col-md-8">
                <p>
                  {{ 'youtube.cookieTextPart1' | transloco }} (<a
                    [href]="'https://www.youtube.com'"
                    [target]="'_blank'"
                    >{{ 'youtube.youtubeLink' | transloco }}</a
                  >){{ 'youtube.cookieTextPart2' | transloco }}
                </p>
                <button
                  (click)="openCookiebotModal($event)"
                  class="btn btn-primary"
                >
                  {{ 'youtube.manageCookies' | transloco }}
                </button>
                <a
                  [href]="
                    'https://www.youtube.com/watch?v=' + component.videoId
                  "
                  [target]="'_blank'"
                >
                  <fa-icon [icon]="faArrow" class="thin"></fa-icon
                  >{{ 'youtube.watchOnYoutube' | transloco }}</a
                >
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
}
